import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@ui-lib/components';

// Расширяем интерфейс ToastService
declare module '@ui-lib/components' {
  interface ToastService {
    localizationError(error: HttpErrorResponse, defaultValue?: string): void;
  }
}

// Добавляем метод к прототипу
ToastService.prototype.localizationError = function (
  error: HttpErrorResponse,
  defaultValue?: string,
): void {
  const serverErrorLocalizationPrefix = 'server-errors';

  const errorMessage = error.error?.localizationDetails?.errorCode
    ? `${serverErrorLocalizationPrefix}.${error.error.localizationDetails.errorCode}`
    : error.error?.messages?.[0];

  this.error({ message: errorMessage ?? defaultValue });
};
